import { roundNumbers } from "../utils";

const getTruePredictions = rows =>
  rows
    ?.filter(r => r.result)
    .sort((a, b) => b.confidence - a.confidence)
    .slice(0, 100);

const getFalsePredictions = rows =>
  rows
    ?.filter(r => !r.result)
    .sort((a, b) => a.confidence - b.confidence)
    .slice(0, 100);

const getContributorValues = (contributors, key, output) =>
  contributors?.map(val => {
    const headerIndex = output.header?.indexOf(val.name);
    const contributorValue = output.value?.[key][headerIndex];
    return `-${val.name}: ${contributorValue}`;
  });

const getProcessedRows = (rows, output) =>
  rows.map(row => {
    const key = parseInt(row.keys?.[0]);
    return {
      name: output.value?.[key][0],
      prediction: row.result,
      confidence: roundNumbers(row.confidence * 100, 2).toFixed(2),
      contributorValues: getContributorValues(row.contributors, key, output),
    };
  });

const getTableData = (summary, output) => {
  const truePredictions = getTruePredictions(summary.rows);
  const falsePredictions = getFalsePredictions(summary.rows);
  return getProcessedRows([...truePredictions, ...falsePredictions], output);
};

export { getTableData };
